// extracted by mini-css-extract-plugin
module.exports = {"gameNameContainer":"_7d2d0ee","buyInContainer":"_41e5700","label":"_b585c12","value":"_ab069f5","gameName":"_c0bc4ca","holdemMaxGameName":"_dfd5cec"};